export default "__VITE_ASSET__DEF_ZkKE__"